const initialValue = {
  itemSelectablePos: [],
  coos: [],
  prices: [],
  poNumber: '',
  qty: '',
}

export default initialValue
